module.exports = "<div class=q-section> <div class=we-main-toggle-container> <a href=# class=\"we-main-toggle-btn active\"> <div class=q-inline-block>Alerts</div> <span class=\"q-pill q-pill-white-and-purple q-marg-left-xs notifications-count\">{%- alertNumber %}</span> </a> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/notificationAlerts/html/notificationsHtml/viewToggler.html
// module id = 1350
// module chunks = 1